// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RHtN","location":"Header_location__vGC05"};